module.exports = __webpack_public_path__ + "static/img/icon_applets.59dbda76.png";